import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import ErrorBoundary from "./ErrorBoundary.jsx";
import { AuthProvider } from "./contexts/AuthContext";
import AuthGate from "./AuthGate.jsx";

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <ErrorBoundary>
      <AuthProvider>
        <AuthGate />
      </AuthProvider>
    </ErrorBoundary>
  </StrictMode>
);

window.setTimeout(() => {
  const bootScreen = document.getElementById("vision-boot-screen");
  if (!bootScreen) return;
  bootScreen.classList.add("is-hidden");
  window.setTimeout(() => bootScreen.remove(), 520);
}, 900);
